module.exports = __webpack_public_path__ + "static/media/cobra.6c80d4da.svg";